import { render } from "./About.vue?vue&type=template&id=cfcd27ac&bindings={}"
import script from "./About.vue?vue&type=script&lang=ts"
export * from "./About.vue?vue&type=script&lang=ts"

import "./About.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script